import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, Modal, Form, Checkbox } from 'react-bootstrap'

import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import { LoadingSpinner } from '../../LoadingSpinner';

export class LineDurationActiveForm extends Component {
    static contextTypes = {
        edition: PropTypes.object,
    }
    constructor(props){
        super(props);

        this.state = {
            noMinimumTimeErrorShow: false,
            noStartHourErrorShow: false,
            noEndHourErrorShow: false,
            invalidTimeRangeErrorShow: false
        };
    }

    onToggleScheduleId(scheduleId) {
        const { form } = this.props;
        const currentIds = form.obj.scheduleIds || [];
        const newIds = currentIds.includes(scheduleId)
            ? currentIds.filter(id => id !== scheduleId)
            : [...currentIds, scheduleId];
        this.props.onToggleScheduleId(newIds);
    }

    onSave(){
        const { form } = this.props;
        const { minimumMinutes, startHour, endHour, useMapPoints } = form.obj;

        const noMinimumTimeErrorShow = !useMapPoints && (!minimumMinutes || Number(minimumMinutes) === 0);
        const noStartHourErrorShow = startHour === undefined;
        const noEndHourErrorShow = endHour === undefined;
        const invalidTimeRangeErrorShow = startHour !== undefined && endHour !== undefined && startHour >= endHour;

        this.setState(
            {
                noMinimumTimeErrorShow,
                noStartHourErrorShow,
                noEndHourErrorShow,
                invalidTimeRangeErrorShow,
            },
            () => {
                if (!noMinimumTimeErrorShow && 
                    !noStartHourErrorShow && 
                    !noEndHourErrorShow && 
                    !invalidTimeRangeErrorShow) {
                    this.props.onSave();
                }
            }
        );
    }
    

    renderError(show, message) {
        return show ? <div style={{ color: 'red', marginLeft: '5px' }}>{message}</div> : null;
    }

    render() {
        const { form } = this.props;

        if(undefined === form) {
            return null;
        }

        const { show  } = this.props;

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>
                        {form.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formMinTime">
                            <ControlLabel>Tempo Mínimo de Minutos Entre Duas Paragens</ControlLabel>
                            <FormControl
                                type="number"
                                min={form.obj.useMapPoints ? "0" : "1"}
                                value={form.obj.minimumMinutes || ''}
                                placeholder="Introduza o tempo mínimo em minutos"
                                onChange={(e) => this.props.onChangeValue(e, 'minimumMinutes')}
                            />
                        </FormGroup>
                        <FormGroup controlId="formUseMapPoints">
                            <Checkbox
                                className="form-checkbox"
                                defaultChecked={form.obj.useMapPoints}
                                onChange={(e) => this.props.onCheckValue(e, "useMapPoints")}>
                                Utilizar Pontos Notáveis como Limite
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formSchedules">
                            <ControlLabel>Horários a Utilizar no Cálculo</ControlLabel>
                            {this.props.schedulesLoading
                                ? <LoadingSpinner />
                                : <div className="line-selection-container scrollable-container">
                                    {(this.props.schedules || []).map(schedule => (
                                        <div key={schedule.id}>
                                            <Checkbox
                                                className="form-checkbox"
                                                checked={(form.obj.scheduleIds || []).includes(schedule.id)}
                                                onChange={() => this.onToggleScheduleId(schedule.id)}>
                                                {schedule.name}
                                            </Checkbox>
                                        </div>
                                    ))}
                                </div>
                            }
                        </FormGroup>

                        <FormGroup controlId="formStartHour">
                            <ControlLabel>Hora de Início</ControlLabel>
                            <div>
                                <TimePicker
                                    onChange={(e) => this.props.onChangeValue(e, 'startHour')}
                                    value={form.obj.startHour || '08:00'}
                                    locale="pt-pt"
                                    format="HH:mm"
                                />
                            </div>
                        </FormGroup>

                        <FormGroup controlId="formEndHour">
                            <ControlLabel>Hora de Fim</ControlLabel>
                            <div>
                                <TimePicker
                                    onChange={(e) => this.props.onChangeValue(e, 'endHour')}
                                    value={form.obj.endHour || '15:00'}
                                    locale="pt-pt"
                                    format="HH:mm"
                                />
                            </div>
                        </FormGroup>
                    </Form>

                    <ButtonToolbar>
                        {this.renderError(this.state.noMinimumTimeErrorShow, 'É necessário definir um tempo mínimo')}
                        {this.renderError(this.state.noStartHourErrorShow, 'É necessário definir uma hora de início')}
                        {this.renderError(this.state.noEndHourErrorShow, 'É necessário definir uma hora de fim')}
                        {this.renderError(this.state.invalidTimeRangeErrorShow, 'A hora de início deve ser menor que a hora de fim')}
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
